import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import i18n from 'i18next';
import Checkbox from '../../Input/Checkbox';
import { SENSITIVE_DATA_CONSENT_TYPE, PRIVACY_CONSENT_TYPE, TOS_CONSENT_TYPE, DATA_NOTICE } from '../../../../common'
import LegalTextService from '../../../../ConsentsLoginModal/LegalTextService';
import LegalDocumentModal from './LegalDocumentModal';

import './Consent.less';

export const legalContentCache = {};

export class Consent extends React.Component {
    static displayName = 'Module.UserSettings.PrivacyView.Consent';
    static propTypes = {
        t: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            isLegalModalOpen: false,
            isLegalLoading: false,
            isLegalError: false,
            legalContent: null,
            legalContentType: null
        };
    }

    onChange = (isChecked) => {
        this.props.onChange(isChecked);
    }

    componentDidMount() {
        this.ensureLegalContentPrefetched();
    }

    hasLegalPopup = (type) => {
        return [PRIVACY_CONSENT_TYPE, TOS_CONSENT_TYPE, DATA_NOTICE, SENSITIVE_DATA_CONSENT_TYPE].indexOf(type) !== -1;
    }

    fetchLegalContent = (type) => {
        if (type === PRIVACY_CONSENT_TYPE) {
            return LegalTextService.getPrivacy(i18n.language);
        }
        if (type === TOS_CONSENT_TYPE) {
            return LegalTextService.getTos(i18n.language);
        }
        if (type === DATA_NOTICE) {
            return LegalTextService.getDataNotice(i18n.language);
        }
        if (type === SENSITIVE_DATA_CONSENT_TYPE) {
            return LegalTextService.getSensitivePersonalInformation(i18n.language);
        }
        return Promise.resolve(null);
    }

    getLegalCacheKey = (type) => {
        return type + ':' + i18n.language;
    }

    isLegalContentEmpty = (legalContent) => {
        if (legalContent === null || legalContent === undefined) {
            return true;
        }
        if (Array.isArray(legalContent)) {
            return legalContent.length === 0;
        }
        if (typeof legalContent === 'object') {
            return Object.keys(legalContent).length === 0;
        }
        return false;
    }

    ensureLegalContentPrefetched = async () => {
        const { type } = this.props;

        if (!this.hasLegalPopup(type)) {
            return;
        }

        const cacheKey = this.getLegalCacheKey(type);
        if (legalContentCache[cacheKey]) {
            if (!this.state.legalContent) {
                this.setState({ legalContent: legalContentCache[cacheKey], legalContentType: type });
            }
            return;
        }

        if (this.state.isLegalLoading) {
            return;
        }

        this.setState({ isLegalLoading: true, isLegalError: false, legalContentType: type });
        try {
            const legalContent = await this.fetchLegalContent(type);
            if (this.isLegalContentEmpty(legalContent)) {
                this.setState({ legalContent: null, isLegalError: true, isLegalLoading: false });
                return;
            }
            legalContentCache[cacheKey] = legalContent;
            this.setState({ legalContent, isLegalLoading: false });
        } catch (error) {
            this.setState({ isLegalError: true, isLegalLoading: false });
        }
    }

    openLegalModal = async (event) => {
        event.preventDefault();
        const { type } = this.props;
        this.setState({ isLegalModalOpen: true });

        if (!this.hasLegalPopup(type)) {
            return;
        }

        if (this.state.legalContent && this.state.legalContentType === type) {
            return;
        }

        await this.ensureLegalContentPrefetched();
    }

    closeLegalModal = () => {
        this.setState({ isLegalModalOpen: false });
    }

    listSensitiveConsents(sensitiveList) {
        const {t} = this.props;
        const sensitiveDataList = [];
      
        for (const sensitiveDataItem of sensitiveList) {
            const translationKey = sensitiveDataItem.dataTypeTranslationKey.replace('gdpr.', 'gdpr:')
            sensitiveDataList.push(<li id={sensitiveDataItem.dataTypeId} key={sensitiveDataItem.dataTypeId} className='sensitive-consent-list'>{`${t(translationKey)}`}</li>)
        }

        return <ul className="sensitive-data-list-items">{sensitiveDataList}</ul>
    }

    render() {
        const { t, url } = this.props;
        var isRequiredToCheck = !this.props.isChecked && this.props.isRequired;
        const isLegalPopupConsent = this.hasLegalPopup(this.props.type);

        const legalReadMore = (
            <span>
                <span> </span>
                <a className="read-more-link" href={url} onClick={this.openLegalModal}>
                    {t('marketing:landing_page.link.read_more', 'Read more')}
                </a>
            </span>
        );

        const legalContentModal = (
            <LegalDocumentModal
                show={this.state.isLegalModalOpen}
                onHide={this.closeLegalModal}
                onClose={this.closeLegalModal}
                isLegalError={this.state.isLegalError}
                isLegalLoading={this.state.isLegalLoading}
                legalContent={this.state.legalContent}
                t={t} />
        );

        return (
            <div className="row">
                <div className="control-group col-md-12 ">
                    <div className="col-md-3 label-wrapper">
                        <div className="left-label">
                            {t(this.props.title)}
                            {this.props.isRequired && '*'}
                        </div>
                    </div>
                    <div className="controls col-md-7">
                        <Checkbox onChange={(event) => this.onChange(event.state.checked)}
                            checked={this.props.isChecked}
                            key={Math.random()}
                            id={"privacy_settings_consent_type_" + this.props.type} />
                        <span className="info_text">
                            {t(this.props.description)}
                        </span>
                        {url && this.props.type !== SENSITIVE_DATA_CONSENT_TYPE && legalReadMore}
                        {this.props.type === SENSITIVE_DATA_CONSENT_TYPE ? (
                          <span className="info_text">
                                                        <a href={this.props.consents.contentUrl} target="_blank" rel="noopener noreferrer" onClick={this.openLegalModal}> {t('common:see_full_details')}</a>
                            {this.listSensitiveConsents(this.props.consents.sensitiveConsentDataTypes)}
                          </span>
                        ) : null}
                        {isRequiredToCheck && <div className="consent-acceptance-required">
                            {t('gdpr:consents.popup.box_unchecked', 'You need to check this box to continue')}
                        </div>}
                        <p className="help-block" />
                        {isLegalPopupConsent && legalContentModal}
                    </div>
                </div>
            </div>
        );
    }
}

Consent.propTypes = {
    isChecked: PropTypes.bool,
    isRequired: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.func,
    type: PropTypes.string,
    url: PropTypes.string,
    consents: PropTypes.object
};

export default translate(['common', 'gdpr', 'marketing', 'legal_document'], { wait: true })(Consent);



// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/Consent/index.jsx